/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useState } from 'react';
// import { Prompt } from 'react-router';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { useRoutePush } from '@micromag/core/contexts';

const propTypes = {
    basePath: PropTypes.string,
    when: PropTypes.bool,
    showModal: PropTypes.bool,
    Modal: PropTypes.elementType,
    modalProps: PropTypes.object, // eslint-disable-line
    onOpened: PropTypes.func,
    onClosed: PropTypes.func,
    withoutUnload: PropTypes.bool,
};

const defaultProps = {
    basePath: null,
    when: false,
    showModal: false,
    Modal: null,
    modalProps: null,
    onOpened: null,
    onClosed: null,
    withoutUnload: false,
};

const PromptModal = ({
    basePath,
    when,
    showModal,
    Modal,
    modalProps,
    onOpened,
    onClosed,
    withoutUnload,
}) => {
    const push = useRoutePush();
    const intl = useIntl();

    const [pendingLocation, setPendingLocation] = useState(null);
    const [modalOpened, setModalOpened] = useState(false);
    const [routeChangeConfirmed, setRouteChangeConfirmed] = useState(false);

    const clearPendingLocation = useCallback(() => {
        setPendingLocation(null);
    }, [setPendingLocation]);

    const openModal = useCallback(() => {
        setModalOpened(true);
        if (onOpened !== null) {
            onOpened();
        }
    }, [setModalOpened, onOpened]);

    const closeModal = useCallback(() => {
        setModalOpened(false);
        if (onClosed !== null) {
            onClosed();
        }
    }, [setModalOpened, onClosed]);

    const onConfirm = useCallback(() => {
        if (pendingLocation !== null) {
            setRouteChangeConfirmed(true);
        }
        closeModal();
    }, [pendingLocation, setRouteChangeConfirmed, closeModal]);

    const onCancel = useCallback(() => {
        closeModal();
        clearPendingLocation();
    }, [closeModal, clearPendingLocation]);

    const onPromptMessage = useCallback(
        (nextLocation) => {
            const outsideBasePath =
                basePath === null || !nextLocation.pathname.startsWith(basePath);
            if (!routeChangeConfirmed && outsideBasePath) {
                setPendingLocation(nextLocation);
                setRouteChangeConfirmed(false);
                openModal();
                return false;
            }
            return true;
        },
        [routeChangeConfirmed, setPendingLocation],
    );

    useEffect(() => {
        if (routeChangeConfirmed && pendingLocation !== null) {
            push(pendingLocation);
            setRouteChangeConfirmed(false);
            clearPendingLocation();
        }
    }, [routeChangeConfirmed, pendingLocation]);

    // Using native popup when exiting / reloading
    useEffect(() => {
        const onUnload = (e) => {
            if (when) {
                // all newer browser ignore the message
                const message = intl.formatMessage({
                    defaultMessage: 'Unsaved changes will be lost, are you sure you want to quit?',
                    description: 'Confirm quit with unsaved changes',
                });
                e.returnValue = message;
                return message;
            }
            return null;
        };
        if (!withoutUnload) {
            window.addEventListener('beforeunload', onUnload);
        }
        return () => {
            if (!withoutUnload) {
                window.removeEventListener('beforeunload', onUnload);
            }
        };
    }, [when, withoutUnload]);

    return (
        <>
            {/* <Prompt when={when} message={onPromptMessage} /> */}
            {modalOpened || showModal ? (
                <Modal {...modalProps} onConfirm={onConfirm} onCancel={onCancel} />
            ) : null}
        </>
    );
};

PromptModal.propTypes = propTypes;
PromptModal.defaultProps = defaultProps;

export default PromptModal;
